const moment = require('moment');
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger'
